import React, { Component } from 'react'
import Checkbox from '../common/Checkbox'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Search from "../../images/search.svg"

class DropdownFilters extends Component {
    constructor() {
        super()
        this.state = {
            lists: {
                Data_Type: [
                    'Audio', 'Image', 'Logs', 'Motion', 'Sensing', 'Text', 'Video'
                ],
                Population: [
                    'Autism', 'Cognitive', 'Developmental', 'Health', 'Hearing', 'Language', 'Learning', 'Mobility', 'Speech', 'Vision'
                ]
            },
            checkedItems: new Map(),
            searchValue: ''
        }
        this.state.keys = Object.keys(this.state.lists)
        this.handleCheckboxListChange = this.handleCheckboxListChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.checkedItems && nextProps.filtersUpdated) {
            this.props.resetFilters();
            nextProps.checkedItems.forEach((key, value) => {
                let item = value;
                let isChecked = key;
                console.log(nextProps.checkedItems)
                if (!isChecked) {
                    this.handleCheckboxListChange(item, isChecked);
                }
            })
        }


    }

    getDataTypeMap(item) {
        const boolToType = ['Audio', 'Image', 'Logs', 'Motion', 'Sensing', 'Text', 'Video']
        let dataTypesArr = []
        boolToType.forEach((type, idx) => {
            if (item[type] === "1") {
                dataTypesArr.push(type)
            }
        })
        return dataTypesArr
    }


    doFilter = (item) => {
        const dataTypes = this.getDataTypeMap(item[0])

        const { Data_Type } = this.state.lists
        const { Population } = this.state.lists

        let found = false

        let anyDatatypes = false
        let foundDatatypes = []
        this.state.checkedItems.forEach((checked, type) => {
            if (Data_Type.includes(type) && !anyDatatypes)
                anyDatatypes = true
            if (dataTypes.includes(type) && checked) {
                console.log("FOUND", dataTypes, dataTypes.includes(type), type)
                foundDatatypes.push(type)
                found = true;
            }
        })
        // if foundDataypes.length!==0 --> weak match
        let anyCategory = false;
        let foundCategory = false;
        this.state.checkedItems.forEach((checked, type) => {
            if (Population.includes(type) && !anyCategory)
                anyCategory = true
        })
        if ((foundDatatypes.length !== 0 && anyDatatypes) || (!anyDatatypes || anyCategory))
            this.state.checkedItems.forEach((checked, type) => {

                // if(type===item[0].Category && checked){
                //     console.log("DONE_categories", item[0].Category, type)
                //     found = true;
                //     foundCategory = true;
                // }
                if (item[0][type] === "1" && checked) {
                    console.log("DONE_categories", item[0].Category, type)
                    found = true;
                    foundCategory = true;
                }
            })
        if (!foundCategory && anyCategory)
            found = false;
        if (foundDatatypes.length === 0 && anyDatatypes)
            found = false;
        // console.log(found, anyDatatypes, anyCategory, foundDatatypes, foundDatatypes.length!==0, item[0].Data_types, item[0].Category)

        return found
    }

    getCatTypeMap = (item) => {
        const boolToType = ['Autism', 'Cognitive', 'Developmental', 'Health', 'Hearing', 'Language', 'Learning', 'Mobility', 'Speech', 'Vision']
        let dataTypesArr = []
        boolToType.forEach((type, idx) => {
            if (item[type] === "1") {
                dataTypesArr.push(type)
            }
        })
        return dataTypesArr
    }

    findMatch = (list) => {
        let set = false
        this.state.checkedItems.forEach((checked, type) => {
            if (list.includes(type) && checked)
                set = true
        })
        // console.log(list, this.state.checkedItems, set)
        return set
    }

    doFilterNew = (item) => {
        const { Data_Type } = this.state.lists
        const { Population } = this.state.lists

        // datatype in item
        const dataTypes = this.getDataTypeMap(item[0])
        // category in item
        const catTypes = this.getCatTypeMap(item[0])
        let found = false

        let onlycat = false
        let onlytype = false
        let both = false
        this.state.checkedItems.forEach((checked, type) => {
            // check if checked item is onlycat, onlytype or both
            if (Population.includes(type) && checked)
                onlycat = true
            if (Data_Type.includes(type) && checked)
                onlytype = true
        })
        if (onlycat && onlytype)
            both = true

        if (onlycat && !both)
            found = this.findMatch(catTypes)
        else if (onlytype && !both)
            found = this.findMatch(dataTypes)
        else {
            let foundCat = this.findMatch(catTypes)
            let foundType = this.findMatch(dataTypes)
            if (foundCat && foundType)
                found = true
        }

        return found
    }

    handleCheckboxListChange = (item, isChecked) => {
        // values is array of selected item. e.g. ['apple', 'banana']
        // const item = e.target.name;
        // const isChecked = e.target.checked;
        let mapCopy = this.state.checkedItems
        // this.setState(prevState => ({ checkedItems: prevState.checkedItems.set(item, isChecked) }));
        console.log(this.state.checkedItems, this.props.items)
        mapCopy.set(item, isChecked)
        let atleast1true = false

        mapCopy.forEach((checked, type) => {
            if (checked) {
                atleast1true = true
            } else {
                mapCopy.delete(type);
            }
        })
        if (this.props.items.length === 0 && !atleast1true) {
            this.props.resetItems()
        }
        if (atleast1true) {
            this.setState({ checkedItems: mapCopy })
        }
        else {
            this.props.resetItems()
        }

        console.log("CHCK", this.state.checkedItems.size, this.props.copyItems, this.state.checkedItems.get(item), atleast1true)

        // if (this.state.checkedItems.size === 1 && !this.state.checkedItems.get(item) && !atleast1true) {
        //     console.log("TRigg")
        //     this.props.resetItems()
        // }
        if (this.state.checkedItems.size > 0) {
            let newItems = []
            this.props.copyItems.forEach(singleItem => {
                if (this.doFilterNew(singleItem)) {
                    newItems.push(singleItem)
                }
            })

            this.props.updateItems(newItems, this.state.checkedItems)

        } else {
            this.props.updateItems(this.props.copyItems, this.state.checkedItems)
        }
    }


    tickOrNot = name => {
        if (this.state.checkedItems.get(name) === undefined)
            return false
        else
            return this.state.checkedItems.get(name)
    }


    isCategoryFiltered = (key) => {
        let mapCopy = this.state.checkedItems
        let isCategoryFiltered = false;
        mapCopy.forEach((checked, type) => {
            if (this.state.lists[key].indexOf(type) >= 0 && checked) {
                isCategoryFiltered = true;
            }
        })
        if (!isCategoryFiltered)
            return 'false'
        else
            return 'true'
    }

    clearCategoryFilter = (key) => {
        let mapCopy = this.state.checkedItems
        mapCopy.forEach((checked, type) => {
            if (this.state.lists[key].indexOf(type) >= 0 && checked) {
                this.state.checkedItems.set(type, false)
                this.setState({ checkedItems: this.state.checkedItems })
                this.handleCheckboxListChange(type, false);
            }
        })

    }


    render() {
        return (
            <nav className="navbar navbar-expand-sm">
                <div className="container">


                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item dropdown">
                            <p className="nav-link dropdown-toggle p-0" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Filters
                            </p>

                            <div className="dropdown-menu p-1 row listheading" aria-labelledby="navbarDropdown" style={{ position: 'absolute', left: '-200px', zIndex: '10', minWidth: '300px', alignItems: 'flex-start' }}>
                                <div className="row container" style={{ alignItems: 'flex-start' }}>
                                    {this.state.keys.map((key, index) => (
                                        <ul key={index} className="dropdown col-6">
                                            <p className="pb-0">{key.replace("_", " ")}</p>
                                            {this.state.lists[key].map((name, idx) => (
                                                <li key={idx} style={{ listStyleType: "none", color: "#000000", borderRadius: "2px" }}>
                                                    <Checkbox className="dropdown-item" name={name} checked={this.tickOrNot(name)} onChange={(e) => this.handleCheckboxListChange(e.target.name, e.target.checked)} />
                                                </li>
                                            ))}
                                        </ul>
                                    ))}
                                </div>
                            </div>
                        </li>
                    </ul>

                </div >
            </nav >
        )
    }
}
export default DropdownFilters;